import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import StoreAPI from '../../../api/store/StoreAPI';
import { SELECTED_STORE_STORAGE_KEY, SHOP_NUMBER_STORAGE_KEY } from '../../../constants/StorageKeysConstants';
import { listerActions } from '../../../redux/lister/actions/ListerActions.creators';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
export const InStoreFilterShoplanding = () => {
    const [shoplandingInfo, setShoplandingInfo] = useState();
    const [shopNumber, setShopNumber] = useState();
    const [inStoreFilter, setInStoreFilter] = useState();
    const { market, servicesApi, lang } = useAemConfig();
    const dispatch = useDispatch();
    useEffect(() => {
        setShopNumber(LocalStorageUtil.getJsonItem(SHOP_NUMBER_STORAGE_KEY));
        setInStoreFilter(LocalStorageUtil.getJsonItem(SELECTED_STORE_STORAGE_KEY));
    }, []);
    useEffect(() => {
        if (!shopNumber || inStoreFilter) {
            return;
        }
        const getShoplandingInfo = () => __awaiter(void 0, void 0, void 0, function* () {
            const shoplandingInfoResponse = yield StoreAPI.getShoplandingInfo(servicesApi, market, shopNumber);
            setShoplandingInfo(shoplandingInfoResponse);
        });
        getShoplandingInfo();
    }, [market, servicesApi, shopNumber, inStoreFilter]);
    useEffect(() => {
        if (!shoplandingInfo) {
            return;
        }
        const { storeId, storeTranslatedProperties } = shoplandingInfo;
        const storeName = storeTranslatedProperties[lang.toUpperCase()].description;
        dispatch(listerActions.updateInStoreFilter({ storeId, storeName }));
        LocalStorageUtil.setItem(SELECTED_STORE_STORAGE_KEY, { storeId, storeName });
    }, [shoplandingInfo]);
    return null;
};
